/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateDefaultInstrumentV2} from '../api'

export const useMutationUpdateDefaultInstrumentV2 = createReactQueryMutationHook('updateDefaultInstrumentV2', updateDefaultInstrumentV2)
